import { CombinedGraphQLErrors } from '@apollo/client/errors';

/**
 * The business code the API refused with, or null when the failure is not one of its
 * refusals (a transport error, or an unknown code).
 *
 * Only the first error is read: this app's mutations resolve a single field, so further
 * entries are the same failure, not a second refusal to render.
 */
export const refusalCode = (error: unknown): string | null => {
    if (!CombinedGraphQLErrors.is(error)) {
        return null;
    }
    const code = error.errors[0]?.extensions?.code;
    return typeof code === 'string' ? code : null;
};
